import { Button, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutKeyboardShortcutsTable extends Layout {
    buttonOpenInNewWindow: Button;
    panelButtons: Panel;
    tableKeyboardShortcuts: Table;
    textboxInput: Textbox;
}
